module.exports = __webpack_public_path__ + "media/wyposazenie/audio@3x-f8c1e765.svg";